export const toggleCaptionIcon = (element: HTMLElement) => {
  const svg = element.querySelector('svg');

  if (!svg) return;

  // Check if the SVG has the class that indicates it's toggled
  const isToggled = svg.classList.toggle('toggled');

  // Change the SVG based on the toggle state
  if (isToggled) {
    // Change to the 'X' SVG
    svg.innerHTML = `<path stroke="currentColor" stroke-width="1" d="M2 2l12 12M2 14l12-12" />`;
    svg.setAttribute('aria-labelledby', 'close-title-id');
  } else {
    // Revert to the original SVG
    svg.innerHTML = `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.2" d="M1.4 14.6h13.2V1.4H1.4z"></path>
                     <path stroke="currentColor" stroke-width="1.2" d="M4 4.5h8m-8 3h8m-8 3h5"></path>`;
    svg.setAttribute('aria-labelledby', 'title');
  }
};
